import { useMutation, UseMutationResult } from '@tanstack/react-query'
import {
  OpalApiRequestBody,
  OpalApiRequestParams,
  OpalApiResponseDocument,
} from '../../../schema'
import { moments } from '../../../v3/moments'

type MomentUpdateParams = {
  id: string
  title?: string
  storyIds?: string[]
}

const buildRequestBody = ({
  id,
  title,
  storyIds,
}: MomentUpdateParams): OpalApiRequestBody<'UpdateMomentV3'> => {
  const storiesCollection = storyIds?.map((storyId) => ({
    id: storyId,
    type: 'story' as const,
  }))
  return {
    data: {
      id,
      type: 'moment',
      attributes: { title },
      relationships: {
        stories: storiesCollection && {
          data: storiesCollection,
        },
      },
    },
  }
}

type MutationParams = {
  onMutate?: (params: MomentUpdateParams) => void
  onSuccess?: (
    data: OpalApiResponseDocument<'ReadMomentV3', 200>,
    params: MomentUpdateParams
  ) => void
  onSettled?: () => void
  query?: OpalApiRequestParams<'UpdateMomentV3'>['query']
}

type UseUpdateMomentResult = UseMutationResult<
  OpalApiResponseDocument<'ReadMomentV3', 200>,
  unknown,
  MomentUpdateParams,
  unknown
>

export function useUpdateMomentMutation({
  onMutate,
  onSuccess,
  onSettled,
  query = {},
}: MutationParams): UseUpdateMomentResult {
  return useMutation({
    mutationFn: (args: MomentUpdateParams) =>
      moments.update({
        params: {
          path: { moment_id: args.id },
          query,
        },
        requestBody: buildRequestBody(args),
      }),
    onSuccess,
    onSettled,
    onMutate,
  })
}
